export default {
  marginBottom: 10
}
